/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { numericDependencies } from './dependenciesNumeric.generated.js';
import { smallerDependencies } from './dependenciesSmaller.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMinTransform } from '../../factoriesAny.js';
export var minTransformDependencies = {
  numericDependencies,
  smallerDependencies,
  typedDependencies,
  createMinTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesMinTransform.generated.js
// module id = 3ZB0
// module chunks = 3